/* Version: 3.5.155 */
'use client';
import { SIDES } from '../components/constants.js';

var offsetBaseX = 20;
var offsetBaseY = 20;
var POPOVER_COMPONENT_NAMES = {
  TOOLTIP: 'Tooltip'
};

// convert sector on screen to side of popover
var sectorToSide = [[SIDES.BOTTOM_RIGHT, SIDES.BOTTOM, SIDES.BOTTOM_LEFT], [SIDES.RIGHT, SIDES.TOP, SIDES.LEFT], [SIDES.TOP_RIGHT, SIDES.TOP, SIDES.TOP_LEFT]];

// different sector values for tooltips
var tooltipSectorToSide = [[SIDES.BOTTOM_RIGHT, SIDES.BOTTOM, SIDES.BOTTOM_LEFT], [SIDES.TOP_RIGHT, SIDES.TOP, SIDES.TOP_LEFT], [SIDES.TOP_RIGHT, SIDES.TOP, SIDES.TOP_LEFT]];

/**
 * Calculate row of row in popover's 3x3 grid
 * @param {number} topRatio - window's top fractioned part
 * @param {number} bottomRatio - window's bottom fractioned part
 * @param {number} innerY - window size y
 * @param {number} refY - position of toggle y
 */
var calcRow = function calcRow(topRatio, bottomRatio, innerY, refY) {
  var row;
  /** Row calculation based on screen height ratio -> topRatio:bottomRatio */
  if (refY < innerY * topRatio) {
    row = 0;
  } else if (refY > innerY * bottomRatio) {
    row = 2;
  } else {
    row = 1;
  }
  return row;
};

/**
 * Calculate position of column in popover's 3x3 grid relative to trigger element
 * @param {number} innerX - window size x
 * @param {number} refX -  position of toggle x
 * @param {number} halfBubble - half the bubbleWidth with error margin
 * @param {number} bubbleWithFloatyWidth - width of bubble with the floaty
 */
var calcCol = function calcCol(innerX, refX, halfBubble, bubbleWithFloatyWidth) {
  var col;
  if (innerX > refX + halfBubble && refX > halfBubble && innerX < refX + bubbleWithFloatyWidth) {
    col = 1;
  } else if (refX < halfBubble || innerX > refX + bubbleWithFloatyWidth) {
    /** Trigger x-axis position < Half the Bubble OR Space available to the right of trigger for full bubble */
    col = 0;
  } else if (refX > halfBubble && innerX < refX + halfBubble) {
    /** Trigger x-postion such that rendering bubble on TOP/BOTTOM/RIGHT not possible */
    col = 2;
  } else {
    col = 1;
  }
  return col;
};

/**
 * Calc position of popover relative to trigger element, based on where the trigger element is positioned on screen.
 * @param {number} innerX - window size x
 * @param {number} innerY - window size y
 * @param {number} refX - position of toggle x
 * @param {number} refY - position of toggle y
 */
var calcSide = function calcSide(innerX, innerY, refX, refY, bubbleWidth) {
  var componentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  /** Half of bubblewidth and error margin */
  var halfBubble = bubbleWidth / 2 + 10;

  /** bubblewidth after floaty appends LEFT/RIGHT position */
  var bubbleWithFloatyWidth = bubbleWidth + 60;
  var row;
  var col = calcCol(innerX, refX, halfBubble, bubbleWithFloatyWidth);
  if (col === 2 || col === 0 && innerX < refX + bubbleWithFloatyWidth) {
    /** screen height 1:1. Removes Right position scenario which overlaps the UI */
    row = calcRow(0.5, 0.5, innerY, refY);
  } else {
    /** screen height 3:7. Top-Right position retention increase and accomodates large height tips */
    row = calcRow(0.3, 0.7, innerY, refY);
  }
  if (componentName === POPOVER_COMPONENT_NAMES.TOOLTIP) {
    return tooltipSectorToSide[row][col];
  }
  return sectorToSide[row][col];
};
var getNubPos = function getNubPos(side) {
  switch (side) {
    case SIDES.BOTTOM:
      return "\n        top: calc(100% + ".concat(offsetBaseY / 2, "px);\n        left: calc(50% - ").concat(offsetBaseX / 2, "px);\n      ");
    case SIDES.BOTTOM_RIGHT:
      return "\n        top: calc(100% + ".concat(offsetBaseY / 2, "px);\n        right: 0;\n      ");
    case SIDES.BOTTOM_LEFT:
      return "\n        top: calc(100% + ".concat(offsetBaseY / 2, "px);\n        left: 0;\n      ");
    case SIDES.RIGHT:
      return "\n        top: 50%;\n        left: calc(100% + ".concat(offsetBaseX, "px);\n      ");
    case SIDES.LEFT:
      return "\n        top:50%;\n        right: calc(100% + ".concat(offsetBaseX, "px);\n      ");
    case SIDES.TOP:
      return "\n        bottom: calc(100% + ".concat(offsetBaseY / 3, "px);\n        left: calc(50% - ").concat(offsetBaseX / 2, "px);\n      ");
    case SIDES.TOP_RIGHT:
      return "\n        bottom: calc(100% + ".concat(offsetBaseY / 3, "px);\n        right: 0;\n      ");
    case SIDES.TOP_LEFT:
      return "\n        bottom: calc(100% + ".concat(offsetBaseY / 3, "px);\n        left: 0;\n      ");
    default:
      return "\n        top: 0px;\n        left: 0px;\n      ";
  }
};
var getBubPos = function getBubPos(side, bubbleWidth) {
  switch (side) {
    case SIDES.BOTTOM:
      return "\n        top: calc(100% + ".concat(offsetBaseY - 5, "px);\n        left: calc(50% - ").concat(Math.round(bubbleWidth / 2), "px);\n      ");
    case SIDES.BOTTOM_RIGHT:
      return "\n        top: calc(100% + ".concat(offsetBaseY - 5, "px);\n        left: calc(100% - ").concat(offsetBaseX * 2, "px);\n      ");
    case SIDES.BOTTOM_LEFT:
      return "\n        top: calc(100% + ".concat(offsetBaseY - 5, "px);\n        right: calc(100% - ").concat(offsetBaseX * 2, "px);\n      ");
    case SIDES.RIGHT:
      return "\n        top: 50%;\n        left: calc(100% + ".concat(offsetBaseX * 2, "px);\n      ");
    case SIDES.LEFT:
      return "\n        top: 50%;\n        right: calc(100% + ".concat(offsetBaseX * 2, "px);\n      ");
    case SIDES.TOP:
      return "\n        bottom: calc(100% + ".concat(offsetBaseY / 2, "px);\n        left: calc(50% - ").concat(Math.round(bubbleWidth / 2), "px);\n      ");
    case SIDES.TOP_RIGHT:
      return "\n        bottom: calc(100% + ".concat(offsetBaseY / 2, "px);\n        left: calc(100% - ").concat(offsetBaseX * 2, "px);\n      ");
    case SIDES.TOP_LEFT:
      return "\n        bottom: calc(100% + ".concat(offsetBaseY / 2, "px);\n        right: calc(100% - ").concat(offsetBaseX * 2, "px);\n      ");
    default:
      return "\n        top: 0px;\n        left: 0px;\n      ";
  }
};
var getSide = function getSide(toggleRef, side, bubbleWidth) {
  var componentName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (side) {
    return side;
  }
  var bounds = toggleRef.current.getBoundingClientRect();
  var x = bounds.x,
    y = bounds.y;
  return calcSide(window.innerWidth, window.innerHeight, x, y, bubbleWidth, componentName);
};

export { POPOVER_COMPONENT_NAMES, calcSide, getBubPos, getNubPos, getSide };
